import { render, staticRenderFns } from "./time-series-periods-select.vue?vue&type=template&id=72177384&scoped=true&"
import script from "./time-series-periods-select.vue?vue&type=script&lang=ts&"
export * from "./time-series-periods-select.vue?vue&type=script&lang=ts&"
import style0 from "./time-series-periods-select.vue?vue&type=style&index=0&id=72177384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72177384",
  null
  
)

export default component.exports